module.exports = __webpack_public_path__ + "static/img/depositBonus.43dd295.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/depositBonus.gif
// module id = 3lY1
// module chunks = 0